import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const FetchCompaniesAction = createAsyncThunk("fetchCompanies",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.fetchCompanyList, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

const FetchCompaniesSlice = createSlice({
    name: "fetchCompanies",
    initialState: {
        isLoading: false,
        data: {},
        error: null
    },
    reducers: {
        FetchCompaniesReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            };
        },
    },
    extraReducers: {
        [FetchCompaniesAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        [FetchCompaniesAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
        },
        [FetchCompaniesAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },
    }
})


export const { FetchCompaniesReset } = FetchCompaniesSlice.actions
export default FetchCompaniesSlice.reducer